/**
 * Klip coupon: injects .elsklip-discounted-price (hides [data-product-price]).
 * Align displayed amounts with theme.settings.moneyFormat (Shopify money_with_currency).
 */
(function () {
  if (!window.__cbKlipCurrencySyncEnabled) return;

  var moneyFormat =
    window.theme && window.theme.settings && window.theme.settings.moneyFormat;

  function parseCents(text) {
    if (!text) return null;
    var match = String(text).trim().match(/-?\$?\s*([\d,]+(?:\.\d{2})?)/);
    if (!match) return null;
    var n = parseFloat(match[1].replace(/,/g, ''));
    return Number.isFinite(n) ? Math.round(n * 100) : null;
  }

  function needsCurrencyCode(text) {
    if (!text) return false;
    var t = String(text).trim();
    if (!t || /\b[A-Z]{3}\b/.test(t)) return false;
    return /^\$[\d,]+(\.\d{2})?$/.test(t);
  }

  function formatEl(el) {
    if (!el || !window.theme || !window.theme.Currency || !moneyFormat) return;
    var t = (el.textContent || '').trim();
    if (!needsCurrencyCode(t)) return;
    var cents = parseCents(t);
    if (cents == null) return;
    var formatted = window.theme.Currency.formatMoney(cents, moneyFormat);
    if ((el.textContent || '').trim() === formatted) return;
    el.textContent = formatted;
  }

  var syncPending = false;

  function syncKlipPrices() {
    document
      .querySelectorAll('.elsklip-discounted-price, .cb-price-row [data-product-price]')
      .forEach(formatEl);
  }

  function scheduleSync() {
    if (syncPending) return;
    syncPending = true;
    window.requestAnimationFrame(function () {
      syncPending = false;
      syncKlipPrices();
    });
  }

  function observe() {
    var root =
      document.querySelector('.product-block--price') ||
      document.querySelector('.cb-price-row');
    if (!root) return;
    syncKlipPrices();
    if (typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      scheduleSync();
    }).observe(root, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  document.addEventListener(
    'change',
    function (e) {
      if (e.target && e.target.closest && e.target.closest('.elsklip-coupon')) {
        setTimeout(syncKlipPrices, 0);
        setTimeout(syncKlipPrices, 250);
        setTimeout(syncKlipPrices, 700);
      }
    },
    true
  );
})();
